import { render, staticRenderFns } from "./OrganizationPanel.vue?vue&type=template&id=127d4f24&"
import script from "./OrganizationPanel.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports